import React from 'react'

type Props = {}

const CustomerChatSvg = (props: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <rect x="6.85645" y="4.04004" width="15.6102" height="20.5075" rx="7.80508" fill="black" />
      <path d="M14.6911 28.5267C20.6414 28.5267 25.4651 23.703 25.4651 17.7526V11.8759C25.4651 5.92552 20.6414 1.10181 14.6911 1.10181C8.74071 1.10181 3.917 5.92552 3.917 11.8759V17.7526C3.917 18.0828 3.91699 18.3954 3.91699 18.7321" stroke="black" stroke-width="1.83649" stroke-linecap="round" />
      <path d="M0 12.3656C0 11.0133 1.0963 9.91699 2.44865 9.91699H4.8973V19.6504H2.44865C1.0963 19.6504 0 18.5541 0 17.2017V12.3656Z" fill="black" />
      <path d="M29.5078 12.3656C29.5078 11.0133 28.4115 9.91699 27.0592 9.91699H24.6105V19.6504H27.0592C28.4115 19.6504 29.5078 18.5541 29.5078 17.2017V12.3656Z" fill="black" />
    </svg>

  )
}

export default CustomerChatSvg